import { createAsyncThunk } from '@reduxjs/toolkit';

import { authGet } from '../../utils/request';

const getUserDetails = createAsyncThunk('users/getUserDetails',
  async (id, { rejectWithValue }) => {
    try {
      const { data: user } = await authGet(`/users/${id}`);
      return user;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  });

export default getUserDetails;
